import { DocumentTypeOption } from "@components/main/documentManagement/DocumentDashboard";

export const DOCUMENT_TYPE_OPTIONS_MAP: Record<string, DocumentTypeOption> = {
  word: { id: "word", label: "Word", ext: ".docx" },
  cell: { id: "cell", label: "Cell", ext: ".xlsx" },
  slide: { id: "slide", label: "Slide", ext: ".pptx" },
  pdf: { id: "pdf", label: "PDF", ext: ".pdf" },
};

export const EDITABLE_FILE_EXTENSIONS: Record<string, string[]> = {
  word: [
    "DOC",
    "DOCM",
    "DOCX",
    "DOT",
    "DOTM",
    "DOTX",
    "EPUB",
    "FB2",
    "FODT",
    "HTM",
    "HTML",
    "HWP",
    "HWPX",
    "MD",
    "MHT",
    "MHTML",
    "ODT",
    "OTT",
    "PAGES",
    "RTF",
    "STW",
    "SXW",
    "TXT",
    "WPS",
    "WPT",
    "XML",
  ],
  cell: [
    "CSV",
    "ET",
    "ETT",
    "FODS",
    "NUMBERS",
    "ODS",
    "OTS",
    "SXC",
    "XLS",
    "XLSM",
    "XLSX",
    "XLT",
    "XLTM",
    "XLTX",
  ],
  slide: [
    "DPS",
    "DPT",
    "FODP",
    "KEY",
    "ODG",
    "ODP",
    "OTP",
    "POT",
    "POTM",
    "POTX",
    "PPS",
    "PPSM",
    "PPSX",
    "PPT",
    "PPTM",
    "PPTX",
    "SXI",
  ],
  pdf: ["DJVU", "DOCXF", "OFORM", "OXPS", "PDF", "XPS"],
  diagram: ["VSDM", "VSDX", "VSSM", "VSSX", "VSTM", "VSTX"],
};
